<template>
    <PlanbordGridCell :style="style" />
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import {WorkloadRequirement} from '@cquential/api';
    import {CSSProperties} from 'vue';
    import Dates from '@cquential/date-utils';
    import {GradientCreator} from '@cquential/utils';
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';

    @Component({
        components: {
            PlanbordGridCell,
        },
    })
    export default class WorkloadRequirementsCell extends Vue {
        @Prop({required: true}) public requirements!: Record<number, WorkloadRequirement>;
        @Prop({required: true}) public fulfillment!: Record<number, number>;
        @Prop({required: true}) public date!: Date;
        @Prop() public nextDate?: Date;
        @Prop({required: true}) public precision!: number;

        public get startTime(): number {
            return this.date.getTime();
        }

        public get endTime(): number {
            if (this.nextDate) {
                return this.nextDate.getTime();
            }

            // TODO this may be off by one hour in timezones with different DST transitions
            return Dates.Utils.addDays(this.date, 1).getTime();
        }

        public get dayDuration(): number {
            return this.endTime - this.startTime;
        }

        public get style(): CSSProperties {
            const gradientCreator: GradientCreator = new GradientCreator(true);
            let previousResult: 'optimum' | 'below-minimum' | 'below-optimum' | 'above-optimum' | 'above-maximum' | null = null;

            for (let time: number = this.startTime; time < this.endTime; time += this.precision) {
                let currentResult: 'optimum' | 'below-minimum' | 'below-optimum' | 'above-optimum' | 'above-maximum';
                const offsetTime: number = time - this.startTime;
                if (time in this.requirements) {
                    const fulfillment: number = this.fulfillment[time] ?? 0;
                    const requirement: WorkloadRequirement = this.requirements[time];
                    if (fulfillment < requirement.minimum) {
                        currentResult = 'below-minimum';
                    } else if (fulfillment < (requirement.minimum + requirement.optimum * 2) / 3) {
                        currentResult = 'below-optimum';
                    } else if (fulfillment > requirement.maximum) {
                        currentResult = 'above-maximum';
                    } else if (fulfillment > (requirement.maximum + requirement.optimum * 2) / 3) {
                        currentResult = 'above-optimum';
                    } else {
                        currentResult = 'optimum';
                    }
                } else {
                    currentResult = 'optimum';
                }

                if (currentResult !== previousResult) {
                    gradientCreator.addStop(`var(--workload-requirement-${currentResult})`, (offsetTime / this.dayDuration * 100));
                    previousResult = currentResult;
                }
            }

            return gradientCreator.getStyleObject();
        }
    }
</script>
